
import React, { useCallback } from 'react';
import { compose, range, toUpper } from 'ramda';
import { connect } from 'react-redux';
import moment from 'moment';

import styleFile from './AvailServiceRoomDetailWithQuota.js';
import RichText from '@synergycms_core/components/generic/RichText';
import { Button, Image } from '@synergycms_core/components/generic/';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';

import Price from '@synergycms_core/components/generic/Price';
import AvailServiceRoomTab from './AvailServiceRoomTab';
import DatepickerService from './DatepickerService';
import actions from '../../../store/actions';
import { Map, OrderedMap, List } from 'immutable';
import {
  SERVICE_TYPE_PER_STAY,
  SERVICE_TYPE_PER_PERSON,
  SERVICE_TYPE_PER_NIGHT,
  SERVICE_TYPE_PER_PERSON_NIGHT
} from '../../../config/constants.js';
import quotaSelectStyles from './quotaSelectStyles.js';
import Select from 'react-select';


class AvailServiceRoomDetailWithQuota extends React.Component {
    static displayName = 'AvailServiceRoomDetailWithQuota';
    constructor(props) {
      super(props);

      this.state = {
        selectedBlock: 1,
        calendarVisibility: false,
        selectedDates: {1: []}
      };
    }

    changeSelectedBlock = (idx) => (e) => {
      this.setState({ selectedBlock: idx });
    }

    toggleCalendar = (visible) => (e) => {
      const { calendarVisibility } = this.state;
      this.setState({
        calendarVisibility: visible ? visible : !calendarVisibility
      });
    }

    changeSelectedDates = (blockIdx = false, dates, cb) => {
      let selectedDatesCopy = {...this.state.selectedDates};
      if(blockIdx) {
        selectedDatesCopy[blockIdx] = dates;
      } else {
        Object.keys(selectedDatesCopy).forEach(key => {
          selectedDatesCopy[key] = dates;
        });
      }
      this.setState({
        selectedDates: selectedDatesCopy
      }, cb && cb());
    }

    isMobile = () => this.props.theme.deviceType !== 'DESK';

    render() {

        const {
          reservationBlocks,
          service,
          changeBlockService,
          serviceBlocks,
          langCode,
          servicePrice,
          serviceTypeText,
        } = this.props.config;

        const {
          blocks,
          setServiceQuantity,
          toggleCalendar,
          removeServiceByTime,
          removeService,
          theme
        } = this.props;

        const {
          classes
        } = theme.styles;

        const {
          selectedBlock,
          calendarVisibility,
          selectedDates
        } = this.state;

        const serviceSelected = blocks.some(block => block.get('services').some(s => s.get('service_id') === service.get('id')));

        return (
        <>
          <div>
            <AddedServicesList
              theme={theme}
              service={service}
              selectedDates={selectedDates}
              changeSelectedDates={this.changeSelectedDates}
              removeServiceByTime={removeServiceByTime}
              setServiceQuantity={setServiceQuantity}
              toggleCalendar={toggleCalendar}
              selectedBlockIdx={selectedBlock}
              reservationBlocks={blocks}/>
          </div>
          <div className={[classes.containerRoomsPrice, calendarVisibility || serviceSelected ? classes.showingRooms : ''].join(' ')}>
            {calendarVisibility || serviceSelected ? (
              <div className={[classes.roomsDetail].join(' ')}>
              {reservationBlocks.size > 1 && reservationBlocks.map(block => (
                <AvailServiceRoomTab
                  key={block.get('idx')}
                  service={service}
                  block={block}
                  selectedBlock={selectedBlock === block.get('idx')}
                  serviceType={service.get('type')}
                  changeBlockService={changeBlockService}
                  serviceBlocks={serviceBlocks}
                  setSelectedBlock={this.changeSelectedBlock} />
              ))}
              </div>
            ) : null }
            <div className={[classes.secondRowFooter, calendarVisibility && this.isMobile() && classes.hideSection].join(' ')}>
              <div className={classes.servicePrice}>
                <Price innerStyle={['boldPrice']} amount={servicePrice} />
                <RichText
                  text={serviceTypeText.text}
                  ucFirst={true}
                  innerStyle={['roboto13SoftGray']}
                  translate={true} />
              </div>
              <AddRemoveServiceBtn
                classes={classes}
                calendarVisibility={calendarVisibility}
                changeSelectedDates={this.changeSelectedDates}
                toggleCalendar={this.toggleCalendar}
                selectedService={service}
                blocks={blocks}
                removeService={removeService}
                langCode={langCode} />
            </div>
          </div>
          {serviceSelected && <CloseServiceBtn
            classes={classes}
            calendarVisibility={calendarVisibility}
            toggleCalendar={this.toggleCalendar}
            selectedService={service}
            blocks={blocks}
          />}
          {calendarVisibility &&
            <DatepickerWrapper
              service={service}
              selectedBlock={selectedBlock}
              dates={selectedDates}
              changeSelectedDates={this.changeSelectedDates}
              reservationBlocks={reservationBlocks}
              classes={classes}
              isMobile={this.isMobile()}
              />}
            {this.isMobile() && calendarVisibility &&
              <div className={classes.secondRowFooter}>
                <div className={classes.servicePrice}>
                  <Price innerStyle={['boldPrice']} amount={servicePrice} />
                  <RichText
                    text={serviceTypeText.text}
                    ucFirst={true}
                    innerStyle={['roboto13SoftGray']}
                    translate={true} />
                </div>
                <AddRemoveServiceBtn
                  classes={classes}
                  calendarVisibility={calendarVisibility}
                  changeSelectedDates={this.changeSelectedDates}
                  toggleCalendar={this.toggleCalendar}
                  selectedService={service}
                  blocks={blocks}
                  removeService={removeService}
                  langCode={langCode} />
              </div>}
        </>
        );
    }
}

const DatepickerWrapper = ({reservationBlocks, selectedBlock, service, dates, changeSelectedDates, classes, isMobile }) => {
  const remainingQuota = calculateRemainingQuota(service, reservationBlocks);

  if(reservationBlocks.size > 1) {
    return (
      reservationBlocks.map(block => (
        <DatepickerService
          key={block.get('idx')}
          service={service}
          blockIdx={block.get('idx')}
          selectedBlock={selectedBlock}
          selectedDates={dates}
          changeSelectedDates={changeSelectedDates}
          reservationBlocks={reservationBlocks}
          remainingQuota={remainingQuota}
          innerStyle={[classes.quotaServicesDatePicker]}
          />
      ))
    )
  } else {
    return (
      <DatepickerService
        service={service}
        blockIdx={selectedBlock}
        selectedBlock={selectedBlock}
        selectedDates={dates}
        changeSelectedDates={changeSelectedDates}
        reservationBlocks={reservationBlocks}
        remainingQuota={remainingQuota}
        innerStyle={[classes.quotaServicesDatePicker]}
        />
    )
  }
}

const AddRemoveServiceBtn = (props) => {

  const {
    toggleCalendar,
    classes,
    langCode,
    removeService,
    selectedService,
    blocks,
    changeSelectedDates,
    calendarVisibility
  } = props;
  let toggleCalendarProps = {
    onClick: toggleCalendar(false),
    innerStyle: ['toggleSecondButton'],
    richText: {
      text: '_%lo quiero%_',
      ucFirst: true,
      innerStyle: [],
      rightIcon: { unicodeContent: langCode === 'AR' ? '005C' : 'e000', innerStyle: ['size12', 'marginLeft5'] },
      translate: true,
    }
  };

  const removeAndToggle = (e) => {
    let serviceBlocks = OrderedMap();
    blocks.forEach((block, idx) => {
      const service = block.get('services').find(s => s.get('service_id') === selectedService.get('id'));
      if(service) {
        serviceBlocks = serviceBlocks.set(idx, Map({ service_id: service.get('service_id') }));
      }
    });

    removeService(serviceBlocks);
    changeSelectedDates(false, []);
    calendarVisibility && toggleCalendar(false)(e);
  }

  if(blocks.some(block => block.get('services').some(s => s.get('service_id') === selectedService.get('id')))) {
    toggleCalendarProps.richText.text = '_%eliminar%_';
    toggleCalendarProps.richText.innerStyle = ['capitalize'];
    toggleCalendarProps.innerStyle = [classes.deleteServiceBtn];
    toggleCalendarProps.richText.rightIcon = {};
    toggleCalendarProps.onClick = removeAndToggle;
  }

  return (
    <div className={[classes.serviceBookButton]}>
      <Button {...toggleCalendarProps}/>
    </div>
  );
}

const CloseServiceBtn = (props) => {
  const {
    toggleCalendar,
    classes,
    calendarVisibility
  } = props;
  let btnProps = {
    onClick: toggleCalendar(false),
    innerStyle: [classes.closeSectionBtn],
    richText:{
      text: '_%cerrar%_',
      translate: true,
      innerStyle: ['roboto13Black','uppercase'],
    }
  };
  if (!calendarVisibility) {
    btnProps.richText.text = '_%abrir%_';
  }
  return (
    <Button {...btnProps}/>
  );
}

const AddedServicesList = (props) => {
  const {
    theme,
    service,
    selectedDates,
    setServiceQuantity,
    removeServiceByTime,
    changeSelectedDates,
    reservationBlocks,
    selectedBlockIdx
  } = props;

  const selectedBlock = reservationBlocks.find(block => block.get('idx') === selectedBlockIdx);
  const addedServices = selectedBlock.get('services', false);

  if(!addedServices.size || !addedServices) return null;

  const addedService = addedServices.find(s => s.get('service_id') === service.get('id'));

  if(!addedService) return null;

  const addedServiceDates = addedService.get('dates', false);

  return (
    <div>
      {addedServiceDates && addedServiceDates.map((date, idx) => (
        <AddedServicesListItem
          date={date}
          key={idx}
          theme={theme}
          setServiceQuantity={setServiceQuantity}
          removeServiceByTime={removeServiceByTime}
          selectedDates={selectedDates}
          changeSelectedDates={changeSelectedDates}
          addedService={addedService}
          reservationBlocks={reservationBlocks}
          selectedBlock={selectedBlock}
          service={service}/>
      ))}
    </div>
  )
}

const AddedServicesListItem = (props) => {
  const {
    date,
    addedService,
    service,
    theme,
    removeServiceByTime,
    changeSelectedDates,
    setServiceQuantity,
    selectedDates, 
    reservationBlocks,
    selectedBlock
  } = props;
  const { classes } = theme.styles;


  const remainingQuota = calculateRemainingQuota(service, reservationBlocks);
  const idx = selectedBlock.get('idx');

  const getServiceQuota = useCallback((date) => {
    return addedService.get('dates').find((d) => {
      return d.get('day') === date.get('day') && d.get('time') === date.get('time');
    }).get('quantity');
  }, [addedService]);

  const getServiceQuotaByDatetime = (service, date) => {
    const day = date.get('day');
    const time = date.get('time', false);

    const worksWithQuotaTime = !!service.get("works_with_quota_time");
    const serviceDay = service.get('days').find(d => d.get('day') === day);

    const maxPerRoom = service.get('max_per_room', false);

    let quota;
    if (worksWithQuotaTime && serviceDay) {
      const serviceBlock = selectedBlock.get('services').find(s => s.get('service_id') === service.get('id'));
      const serviceDayBlock = serviceBlock.get('dates').find(d => d.get('day') === day && d.get('time') === time);
      const quantity = serviceDayBlock ? serviceDayBlock.get('quantity') : 0;
      quota = remainingQuota[`${day}-${time}`] + quantity;
    } else {
      const serviceBlock = selectedBlock.get('services').find(s => s.get('service_id') === service.get('id'));
      const serviceDayBlock = serviceBlock.get('dates').find(d => d.get('day') === day);
      const quantity = serviceDayBlock ? serviceDayBlock.get('quantity') : 0;
      quota = remainingQuota[day] + quantity;
    }

    return maxPerRoom ? Math.min(quota, maxPerRoom) : quota;
  };

  const changeServiceQuantity = useCallback((e) => {
    const { value } = e;
    setServiceQuantity(idx, addedService.get('service_id'), parseInt(value), date);
  },[
    idx, 
    addedService, 
    date, 
    setServiceQuantity
  ]);

  const removeService = useCallback(() => {
    removeServiceByTime(idx, addedService.get('service_id'), date);
    changeSelectedDates(idx, selectedDates[idx]?.filter(day => day !== date.get('day')) || []);
  },[
    idx, 
    addedService, 
    date, 
    removeServiceByTime, 
    changeSelectedDates, 
    selectedDates
  ]);

  const hasQuotaSelect = ![
    SERVICE_TYPE_PER_STAY,
    SERVICE_TYPE_PER_NIGHT,
    SERVICE_TYPE_PER_PERSON,
    SERVICE_TYPE_PER_PERSON_NIGHT
  ].includes(toUpper(service.get('type')));


  const dayDate = moment(date.get('day')).format('D MMMM');
  const timeDate = date.get('time', false) ? moment(date.get('time'), 'HH:mm') : false;

  const totalOccupants = selectedBlock.get('adults') + selectedBlock.get('childs', 0);
  const selectedQuantity = getServiceQuota(date);
  const isRelevantService = [
    SERVICE_TYPE_PER_PERSON, 
    SERVICE_TYPE_PER_PERSON_NIGHT
  ].includes(service.get('type').toUpperCase());
  
  const showWarning = isRelevantService && selectedQuantity < totalOccupants;

  return (
    <div key={idx} className={classes.quotaListItem}>
      <RichText
        text={dayDate}
        translate={false}
        innerStyle={[classes.textDate]}
        />
      { timeDate && (<RichText
        text={`${timeDate.format('HH:mm')}h`}
        translate={false} />)}
      { hasQuotaSelect && <QuotaSelect
        theme={theme}
        selectedQuota={getServiceQuota(date)}
        quotaLimit={getServiceQuotaByDatetime(service, date)}
        changeServiceQuantity={changeServiceQuantity}/>}
      <Image 
        onClick={removeService} 
        unicodeContent={'e001'} 
        innerStyle={['size15', classes.deleteServiceBtn]} 
      />
      {showWarning && <RichText
        text={'_%atencion no hay disponibilidad para todos los huespedes%_'}
        translate={true}
        innerStyle={[classes.textWarning]}
        ucFirst={true}
        />}
    </div>
  )
}

const QuotaSelect = ({ changeServiceQuantity, selectedQuota, quotaLimit, theme }) => {
  const selectLimit = quotaLimit + 1;
  
  const options = List(range(1, selectLimit).map( value => {
    return { "value": value, "label": value }
  }));
  
  const currentOption = options.find(h => h.value === selectedQuota);
  const { classes } = theme.styles;

  return (
    <div className={classes.quotaSelectContainer}>
      <Select
        getOptionLabel={option => option.label}
        getOptionValue={option => option.value}
        isSearchable={false}
        onChange={changeServiceQuantity}
        styles={quotaSelectStyles(theme.themeValues.mainColor)}
        value={currentOption}
        options={options}
      />
    </div>
  )
};

const mapStateToProps = (store, ownProps) => {

  return {
    blocks: store.getIn(['customer', 'reservation_request', 'blocks']).reduce((result, block) => {
      return result.set(block.get('idx'), block);
    }, new Map()),
  };
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setServiceQuantity: (idx, serviceId, quantity, date) => {
      dispatch(actions.customer.reservationRequest.setServiceQuantity(idx, serviceId, quantity, date));
    },
    removeServiceByTime: (idx, serviceId, date) => {
      dispatch(actions.customer.reservationRequest.removeServiceByTime(idx, serviceId, date));
    },
    removeService: serviceBlocks => {
      dispatch(actions.customer.reservationRequest.removeService(serviceBlocks));
    }
  }
};


const calculateRemainingQuota = (service, reservationBlocks) => {
  return service.get('days', List()).reduce((result, day) => {
    if(!service.get('works_with_quota_time')) {
      result[day.get('day')] = day.get('quota');
      reservationBlocks.forEach(block => {
        const serviceBlock = block.get('services').find(s => s.get('service_id') === service.get('id'));
        if(serviceBlock) {
          const serviceDay = serviceBlock.get('dates').find(d => d.get('day') === day.get('day'));
          if(serviceDay) {
            const quota = serviceDay.get('quantity');
            if(result[day.get('day')] > 0) {
              result[day.get('day')] = result[day.get('day')] - quota;
            }
          }
        }
      });
      return result;
    } else {
      day.get('quotas_time').forEach(time => {
        result[`${day.get('day')}-${time.get('time')}`] = time.get('quota');
        reservationBlocks.forEach(block => {
          const serviceBlock = block.get('services').find(s => s.get('service_id') === service.get('id'));
          if(serviceBlock) {
            const serviceDay = serviceBlock.get('dates').find(d => d.get('day') === day.get('day') && d.get('time') === time.get('time'));
            if(serviceDay) {
              const quota = serviceDay.get('quantity');
              if(result[`${day.get('day')}-${time.get('time')}`] > 0) {
                result[`${day.get('day')}-${time.get('time')}`] = result[`${day.get('day')}-${time.get('time')}`] - quota;
              }
            }
          }
        });
      });
      return result;
    }
  }, {});
}

export default compose(
  PropertyManager([
    'reservationBlocks',
    'showRoomsDetail',
    'service',
    'changeServiceQuantity',
    'setServiceQuantity',
    'changeBlockService',
    'serviceBlocks',
    'langCode',
    'servicePrice',
    'serviceTypeText',
    'blocks',
    'removeServiceByTime',
    'removeService'
  ]),
  connect(
      mapStateToProps,
      mapDispatchToProps
  ),
  withThemeJSS({ styleFile, link: true })
)(AvailServiceRoomDetailWithQuota);